import React, {Component} from 'react';
import './notfound.css';

export default class NotFound extends Component{
  render(){
    return (
      <section className='notfound-container'>
        <h1 id='page-title'>404 Not Found</h1>
      </section>
    )
  }
}